import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import CompleteRegistration from './views/CompleteRegistration.vue';
import ForgetPassword from './views/ForgetPassword.vue'
import ChangePassword from './views/ChangePassword'
import Dashboard from './views/Dashboard.vue';
import Documentation from './views/Documentation.vue'
import Survey from './views/Survey.vue'
import SurveyOption from './views/SurveyOption'
import CreateSurvey from './views/CreateSurvey.vue'
import Result from './views/Result.vue'
import Company from './views/Company.vue'
import CompanyAdd from './views/CompanyAdd.vue'
import Employee from './views/Employee.vue'
import RoadMap from './views/RoadMap.vue'
import EmployeeAdd from './views/EmployeeAdd.vue'
import EmployeeProfile from "./views/EmployeeProfile";
import Provider from './views/Provider.vue'
import ProviderAdd from './views/ProviderAdd.vue'
import ProviderProfile from "./views/ProviderProfile";
import DocumentationDetail from './views/DocumentationDetail.vue'
import AdminUserList from './views/administration/UserList.vue'
import adminUserTypeList from './views/administration/UserTypeList.vue'
import adminUserTypeAdd from './views/administration/UserTypeAdd.vue'
import adminPermissions from './views/administration/Permissions'
import AdminUserDetail from './views/administration/UserDetail.vue'
import AdminResultTagAdd from './views/administration/ResultTagAdd'
import AdminUserAdd from './views/administration/UserAdd.vue'
import AdminDocumentation from './views/administration/Documentation.vue'
import AdminResult from './views/administration/Results.vue'
import AdminTranslation from './views/administration/Translation.vue'
import AdminQuestionnnary from './views/administration/Questionnary.vue'
import AdminQuestionTag from './views/administration/QuestionTagAdd'
import AdminEditQuestionTag from './views/administration/QuestionTagEdit'
import AdminAddQuestion from './views/administration/QuestionAdd'
import AdminCompanyList from './views/administration/CompanyList'
import AdminEditQuestion from './views/administration/QuestionEdit'
import ProviderSurvey from './views/ProviderSurvey'
import ProviderResult from './views/ProviderResult'
import ReportSurvey from "./views/administration/ReportSurvey"
import ReportAlert from './views/administration/ReportAlert'
import ReportStats from './views/administration/ReportStats'
import DocumentationAdd from './views/administration/DocumentationAdd.vue'
import DocumentationEdit from './views/administration/DocumentationEdit.vue'
import CategoryAdd from './views/administration/CategoryAdd'
import CategoryEdit from './views/administration/CategoryEdit.vue'
import Legals from './views/Legals.vue'
import AttendanceMonitoring from './views/AttendanceMonitoring.vue'
import Cookies from './views/Cookies.vue'
import Confidentiality from './views/Confidentiality.vue'
import RawResult from './views/RawResult.vue'
import ReviewDeposit from './views/ReviewDeposit.vue'
import layout from '@/layouts/layout'
import store from './_store'
import ProviderDetail from "./views/administration/ProviderDetail";

Vue.use(Router);

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next();
    return
  }
  next('/dashboard')
}

const ifAuthenticated = (to, from, next) => {
  console.log('im a trigered');
  if (store.getters.isAuthenticated) {
    next();
    return
  }
  next('/')
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/dashboard',
      component: layout,
      beforeEnter: ifAuthenticated,
      children: [{
          path: '/',
          name: 'dashboard',
          component: Dashboard,
        },
        {
          path: '/company',
          name: 'company',
          component: Company,
        },
        {
          path: '/company/add',
          name: 'companyadd',
          component: CompanyAdd,
        },
        {
          path: '/attendance-monitoring/',
          name: 'roadmap',
          component: AttendanceMonitoring,
        },
        {
          path: '/plan-actions',
          name: 'roadmap',
          component: RoadMap,
        },
        {
          path: '/users/list',
          name: 'employee',
          component: Employee,
        },
        {
          path: '/users/list/add',
          name: 'employeeadd',
          component: EmployeeAdd,
        },
        {
          path: '/users/list/profile/:id',
          name: 'employeeprofile',
          component: EmployeeProfile,
        },
        {
          path: '/users/providers',
          name: 'provider',
          component: Provider,
        },
        {
          path: '/users/providers/add',
          name: 'provideradd',
          component: ProviderAdd,
        },
        {
          path: '/users/providers/profile/:id',
          name: 'providerprofile',
          component: ProviderProfile,
        },
        {
          path:'/get-report',
          name:'report',
          component: Result
        },
        {
          path: '/rawresults',
          name: 'dashboard',
          component: RawResult,
        },
        {
          path: '/survey-option',
          name: 'surveyOption',
          component: SurveyOption,
        },
        {
          path: '/providersurvey',
          name: 'surveyOption',
          component: ProviderSurvey,
        },
        {
          path: '/providerresult',
          name: 'surveyOption',
          component: ProviderResult,
        },
        {
          path: '/survey',
          name: 'survey',
          component: Survey,
        },
        {
          path: '/survey/:action/',
          name: 'createSurvey',
          component: CreateSurvey,
        },
        {
          path: '/survey/:action/:id',
          name: 'createSurvey',
          component: CreateSurvey,
        },
        {
          path: '/reviewdeposit',
          name: 'dashboard',
          component: ReviewDeposit,
        },
        {
          path: '/documentation',
          name: 'documentation',
          component: Documentation,
        },
        {
          path: '/documentation/detail/:id/',
          name: 'documentationDetail',
          component: DocumentationDetail,
        },
        {
          path: 'administration/userlist/',
          name: 'adminUserList',
          component: AdminUserList,
        },
        {
          path: 'administration/usertype/list/',
          name: 'adminUserTypeList',
          component: adminUserTypeList,
        },
        {
          path: 'administration/permissions/',
          name: 'adminPermissions',
          component: adminPermissions,
        },
        {
          path: 'administration/usertype/add/',
          name: 'adminUserTypeAdd',
          component: adminUserTypeAdd,
        },
        {
          path: 'administration/usertype/:id/',
          name: 'adminUserTypeAdd',
          component: adminUserTypeAdd,
        },
        {
          path: 'administration/permissions/',
          name: 'adminPermission',
          component: adminPermissions,
        },
        {
          path: 'administration/companies/',
          name: 'adminUserList',
          component: AdminCompanyList,
        },
        {
          path: 'administration/user/add',
          name: 'adminUserList',
          component: AdminUserAdd,
        },
        {
          path: 'administration/user/:id/',
          name: 'adminUserList',
          component: AdminUserDetail,
        },
        {
          path: 'administration/provider/:id/',
          name: 'adminUserList',
          component: ProviderDetail,
        },
        {
          path: 'administration/results/',
          name: 'adminResult',
          component: AdminResult,
        },
        {
          path: 'administration/result/tag/add',
          name: 'adminResult',
          component: AdminResultTagAdd,
        },
        {
          path: 'administration/translation/',
          name: 'adminTranslation',
          component: AdminTranslation,
        },
        {
          path: 'administration/questionnary/',
          name: 'adminQuestionnary',
          component: AdminQuestionnnary,
        },
        {
          path: 'administration/questionnary/tag/add',
          name: 'adminAddQuestionTag',
          component: AdminQuestionTag,
        },
        {
          path: 'administration/questionnary/tag/edit/:id/',
          name: 'adminEditQuestionTag',
          component: AdminEditQuestionTag,
        },
        {
          path: 'administration/questionnary/question/add/:core/',
          name: 'adminAddQuestion',
          component: AdminAddQuestion,
        },
        {
          path: 'administration/questionnary/question/edit/:id/',
          name: 'adminEditQuestion',
          component: AdminEditQuestion,
        },
        {
          path: 'administration/documentation/',
          name: 'adminDocumentation',
          component: AdminDocumentation,
        },
        {
          path: 'administration/documentation/add/:filetype/',
          name: 'adminDocumentationAddFileType',
          component: DocumentationAdd,
        },
        {
          path: 'administration/documentation/add/:filetype/',
          name: 'adminDocumentationAddFileType',
          component: DocumentationAdd,
        },
        {
          path: 'administration/documentation/add/:filetype/',
          name: 'adminDocumentationAddFileType',
          component: DocumentationAdd,
        },
        {
          path: 'administration/documentation/add',
          name: 'adminDocumentationAdd',
          component: DocumentationAdd,
        },
        {
          path: 'administration/documentation/edit/:id',
          name: 'adminDocumentationEdit',
          component: DocumentationEdit,
        },
        {
          path: 'administration/documentation/category/add',
          name: 'adminCategoryEdit',
          component: CategoryAdd,
        },
        {
          path: 'administration/documentation/category/edit/:id',
          name: 'adminCategoryEdit',
          component: CategoryEdit,
        },
        {
          path: 'administration/reporting/survey',
          name: 'reportingSurvey',
          component: ReportSurvey,
        },
        {
          path: 'administration/reporting/alerts',
          name: 'reportingAlert',
          component: ReportAlert,
        },
        {
          path: 'administration/reporting/stats',
          name: 'reportingStats',
          component: ReportStats,
        }]
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/complete-registration/:token/',
      name: 'completeRegistration',
      component: CompleteRegistration,
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/forget-password/',
      name: 'forgetPassword',
      component: ForgetPassword,
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/change-password/:token/',
      name: 'changePassword',
      component: ChangePassword,
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/legals/',
      name: 'legals',
      component: Legals,
    },
    {
      path: '/confidentiality/',
      name: 'confidentiality',
      component: Confidentiality,
    },
    {
      path: '/cookies/',
      name: 'cookies',
      component: Cookies,
    }]
});
